<template>
    <SuniCalculator />
</template>

<script>
import SuniCalculator from "./components/SuniCalculator.vue";

export default {
    name: "App",
    components: {
        SuniCalculator,
    },
};
</script>

<style></style>
